export const SORT_TYPES = {
  default: 'resi_sort_v2',
  defaultDesc: 'resi_sort_v2_desc',
  newlyAdded: 'asset_activation_dt_sort',
  propertyAddress: 'resi_property_address',
  auctionStartDate: 'auction_date_order',
  beds: 'beds',
  baths: 'baths',
  sqft: 'sqft',
  valuationEstimate: 'valuation_estimate',
  distance: 'distance',
}

export const SORT_TYPES_DESC_OVERRIDE = {
  starting_bid_sort: 'starting_bid_sort_desc',
  asset_activation_dt_sort: 'asset_activation_dt_sort_desc',
}

export const SORT_ORDERS = {
  desc: 'desc',
  asc: 'asc',
}

// setup to work with semantic dropdown easily
const RECOMMENDED_SORT = { text: 'Recommended', value: SORT_TYPES.default }
const NEWLY_ADDED_SORT = { text: 'Newly Added', value: SORT_TYPES.newlyAdded }
const ADDRESS_SORT = { text: 'Address', value: SORT_TYPES.propertyAddress }
const DISTANCE_SORT = { text: 'Distance', value: SORT_TYPES.distance }
const AUCTION_DATES_SORT = {
  text: 'Auction Date',
  value: SORT_TYPES.auctionStartDate,
}
const BEDS_SORT = { text: 'Beds', value: SORT_TYPES.beds }
const BATHS_SORT = { text: 'Baths', value: SORT_TYPES.baths }
const SQFT_SORT = { text: 'Square Feet', value: SORT_TYPES.sqft }
const VALUATION_ESTIMATE_SORT = {
  text: 'Price',
  value: SORT_TYPES.valuationEstimate,
}

export const ARVSortOptionsOrder = [
  RECOMMENDED_SORT,
  NEWLY_ADDED_SORT,
  DISTANCE_SORT,
  ADDRESS_SORT,
  AUCTION_DATES_SORT,
  BEDS_SORT,
  BATHS_SORT,
  SQFT_SORT,
  VALUATION_ESTIMATE_SORT,
]

// SRP Sort Experiment (fe.resi.srp-sort-experiment-v1)
export const EXPERIMENT_FLAG_KEY = 'fe.resi.srp-sort-experiment-v1'

/**
 * Returns whether the user is in the sort experiment (control or treatment).
 */
export const isInSortExperiment = flagValue =>
  flagValue === 'control' || flagValue === 'treatment'

/**
 * Maps experiment flag value to analytics experiment group label.
 * "control" → "A", "treatment" → "B", else null.
 */
export const getExperimentGroup = flagValue => {
  if (flagValue === 'control') return 'A'
  if (flagValue === 'treatment') return 'B'
  return null
}

/**
 * Returns the sort_applied analytics field value.
 * Only returns a value when the user is on the Recommended sort (resi_sort_v2).
 * Returns null if the user selected a different sort.
 */
/**
 * Returns the sort_applied analytics field value.
 * Emits when user is on their group's intended default sort, null otherwise.
 */
export const getSortApplied = (flagValue, currentSortType) => {
  if (flagValue !== 'control' && flagValue !== 'treatment') return null

  const defaultSortForGroup =
    flagValue === 'treatment' ? SORT_TYPES.default : SORT_TYPES.auctionStartDate

  if (currentSortType && currentSortType !== defaultSortForGroup) return null

  return flagValue === 'control'
    ? 'recommended_control'
    : 'recommended_treatment'
}
